import { client } from 'repositories/client';
import { paths } from 'repositories/configurationProfile/paths';
import {
  CheckRegistrationResponse,
  CreateSessionTokenResponse,
} from 'repositories/configurationProfile/responseType';
import { InvalidParameterError } from 'repositories/Error';
import { getRequestPath } from 'utils/string';
import { APIDomain } from 'models/API';

type CreateSessionTokenArgs = {
  auth: {
    authorizationToken?: string;
    iphoneRegistrationToken?: string;
  };
  distribution: {
    accessKey?: string;
    passKey?: string;
    deviceName?: string;
  };
  appId?: string;
  reInstall?: boolean;
};

const createSessionToken = async (
  args: CreateSessionTokenArgs
): Promise<string> => {
  if (
    args.auth.authorizationToken === undefined &&
    args.auth.iphoneRegistrationToken === undefined &&
    args.distribution.accessKey === undefined &&
    args.reInstall === false
  ) {
    throw new InvalidParameterError(
      'セッションを作成するためのパラメータが足りません'
    );
  }
  const params = new FormData();
  if (args.auth.authorizationToken) {
    params.append('authorization_token', args.auth.authorizationToken);
  }
  if (args.auth.iphoneRegistrationToken) {
    params.append(
      'iphone_registration_token',
      args.auth.iphoneRegistrationToken
    );
  }
  if (args.distribution.accessKey) {
    params.append('distribution_access_key', args.distribution.accessKey);
  }
  if (args.distribution.passKey) {
    params.append('key', args.distribution.passKey);
  }
  if (args.distribution.deviceName) {
    params.append('name', args.distribution.deviceName);
  }
  if (args.appId) {
    params.append('app_id', args.appId);
  }
  if (args.reInstall) {
    params.append('reinstall', '1');
  }

  const response = await client.post<CreateSessionTokenResponse>(
    paths.sessions,
    params
  );
  return response.data.results.profile_token;
};

const downloadUrl = (token: string): string => {
  const params = {
    ['profile_token']: token,
  };

  // TODO: urlの生成が力技なので、api系のurl生成メソッド的なのを別途用意する
  return getRequestPath(APIDomain.path(`/api${paths.show}`), params);
};

const checkProfileTokenValidation = async (token: string): Promise<boolean> => {
  const params = {
    ['profile_token']: token,
  };

  const response = await client.get(paths.show, {
    params: params,
  });

  return response.status === 200;
};

const checkRegistration = async (
  token: string
): Promise<CheckRegistrationResponse> => {
  const params: { [key: string]: string } = {};
  params['profile_token'] = token;
  const response = await client.get<CheckRegistrationResponse>(
    paths.checkRegistration,
    { params }
  );

  return response.data;
};

export const configurationProfile = {
  createSessionToken,
  downloadUrl,
  checkProfileTokenValidation,
  checkRegistration,
};
